const customPaperStyles = {
  customPaper: {
    borderRadius: "13px",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
    border: "none",
  },
  customPaperMobile: {
    border: "none",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
  },
} as const;

export default customPaperStyles;
